import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notificationsInfo$ = new ReplaySubject<any>();
 
   private baseUrl = `${environment.host}/api/Notification`;
   private http: HttpClient;
 
   constructor(http: HttpClient) {
     this.http = http;
   }

   getNotificationsCount() {
     return this.http.get<any>(`${this.baseUrl}/info`); 
   }

    getNotifications(PageIndex:number, PageSize:number, category?: 'general' | 'tar') { 
      const params: Record<string, string> = {
        PageIndex: PageIndex.toString(),
        PageSize: PageSize.toString()
      };
      if (category) {
        params['category'] = category;
      }
      return this.http.get<any>(`${this.baseUrl}/notifications`, { params }); 
    }

    getNotificationsEppRequest(PageIndex:number, PageSize:number) { 
      return this.http.get<any>(`${this.baseUrl}/notificationsEppRequest`,{ params: { PageIndex: PageIndex.toString(), PageSize: PageSize.toString() } }); 
    }

    getNotificationsInspection(PageIndex:number, PageSize:number) { 
      return this.http.get<any>(`${this.baseUrl}/notificationsInspection`,{ params: { PageIndex: PageIndex.toString(), PageSize: PageSize.toString() } }); 
    }

    markNotificationsAsRead(notificationIds: number[], pageIndex: number = 0, pageSize: number = 10, readed = true) {
      return this.http.post<any>(
      `${this.baseUrl}/markNotificationsAsRead`,
      { notificationIds, pageIndex , pageSize, readed}
      );
    }

    markEppRequestNotificationsAsRead(notificationIds: number[], pageIndex: number = 0, pageSize: number = 10, readed = true) {
      return this.http.post<any>(
      `${this.baseUrl}/markEppRequestNotificationsAsRead`,
      { notificationIds,  pageIndex , pageSize, readed }
      );
    }

    markInspectionsNotificationsAsRead(notificationIds: number[], pageIndex: number = 0, pageSize: number = 10, readed = true) {
      return this.http.post<any>(
      `${this.baseUrl}/markInspectionsNotificationsAsRead`,
      { notificationIds,  pageIndex , pageSize ,readed}
      );
    }



    deleteNotification(notificationIds: number[]) {
      return this.http.request<any>(
        'delete',
        `${this.baseUrl}/deleteNotification`,
        { body: { notificationIds } }
      );
    }

    deleteEppRequestNotification(notificationIds: number[]) {
      return this.http.request<any>(
        'delete',
        `${this.baseUrl}/deleteEppRequestNotification`,
        { body: { notificationIds } }
      );
    }

    deleteInspectionsNotification(notificationIds: number[]) {
      return this.http.request<any>(
        'delete',
        `${this.baseUrl}/deleteInspectionsNotification`,
        { body: { notificationIds } }
      );
    }
}
